export default __webpack_public_path__ + "static/media/HeroImageInvestimentos.1ffad228.png";